const STORAGE_KEY = "connectz-saved-login";

export interface SavedLogin {
  email: string;
  password: string;
  remember: boolean;
  savedAt: number;
}

export const SAVED_LOGIN_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function subscribeSavedLogin(onChange: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
}

let savedSnapshotRaw: string | null | undefined;
let savedSnapshot: SavedLogin | null = null;

export function readSavedLogin(): SavedLogin | null {
  if (typeof window === "undefined") return null;
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
  } catch {
    raw = null;
  }
  if (raw === savedSnapshotRaw) return savedSnapshot;
  savedSnapshotRaw = raw;
  savedSnapshot = loadSavedLogin();
  return savedSnapshot;
}

export function emptySavedLogin(): null {
  return null;
}

export function loadSavedLogin(): SavedLogin | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SavedLogin>;
    if (!parsed.remember || !parsed.email) return null;
    const savedAt = Number(parsed.savedAt) || Date.now();
    if (Date.now() - savedAt > SAVED_LOGIN_MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return {
      email: parsed.email,
      password: parsed.password ?? "",
      remember: true,
      savedAt,
    };
  } catch {
    return null;
  }
}

export function saveLogin(email: string, password: string): void {
  if (typeof window === "undefined") return;
  try {
    const payload: SavedLogin = {
      email,
      password,
      remember: true,
      savedAt: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}

export function clearSavedLogin(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
